module.exports = __webpack_public_path__ + "assets/img/National-Media-Social-Static-Ad-w540.10d2f593.webp";